var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.captionText !== '')?_c('div',{staticClass:"closed-captions",class:_vm.isCaptionTop ? 'top' : 'bottom'},[_c('span',{staticClass:"closed-captions-text"},[_vm._v(_vm._s(_vm.captionText))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }